import { Button, Tooltip } from 'antd';
import { useTranslate } from '@tolgee/react';
import { ReactNode } from 'react';

export const FakeRefuseButton = ({ title }: { title?: ReactNode }) => {
  const { t } = useTranslate();
  return (
    <Tooltip
      title={title || t('根据Tiktok政策，该退单申请不支持拒绝，如需拒绝请前往卖家中心联系平台客服')}
    >
      <Button type="link" disabled>
        {t('tableColumn.拒绝')}
      </Button>
    </Tooltip>
  );
};

FakeRefuseButton.displayName = 'FakeRefuseButton';
